/* tslint:disable */
/* eslint-disable */
/**
 * SONeu.WebApi | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { DocumentGroup } from './DocumentGroup';
import {
    DocumentGroupFromJSON,
    DocumentGroupFromJSONTyped,
    DocumentGroupToJSON,
    DocumentGroupToJSONTyped,
} from './DocumentGroup';

/**
 * 
 * @export
 * @interface MoveDocumentRequest
 */
export interface MoveDocumentRequest {
    /**
     * 
     * @type {DocumentGroup}
     * @memberof MoveDocumentRequest
     */
    target: DocumentGroup;
    /**
     * 
     * @type {string}
     * @memberof MoveDocumentRequest
     */
    fileId: string;
}



/**
 * Check if a given object implements the MoveDocumentRequest interface.
 */
export function instanceOfMoveDocumentRequest(value: object): value is MoveDocumentRequest {
    if (!('target' in value) || value['target'] === undefined) return false;
    if (!('fileId' in value) || value['fileId'] === undefined) return false;
    return true;
}

export function MoveDocumentRequestFromJSON(json: any): MoveDocumentRequest {
    return MoveDocumentRequestFromJSONTyped(json, false);
}

export function MoveDocumentRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): MoveDocumentRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'target': DocumentGroupFromJSON(json['target']),
        'fileId': json['fileId'],
    };
}

export function MoveDocumentRequestToJSON(json: any): MoveDocumentRequest {
    return MoveDocumentRequestToJSONTyped(json, false);
}

export function MoveDocumentRequestToJSONTyped(value?: MoveDocumentRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'target': DocumentGroupToJSON(value['target']),
        'fileId': value['fileId'],
    };
}

